





















import { PageModule } from "@/store/module/page";
import tabLatent from "./latent/index.vue";
import tabRecycle from "./recycle/index.vue";
import tabWaiting from "./waiting/index.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import eventBus from "@/utils/bus";
@Component({
  name: "recruitManagement",
  components: {
    tabLatent,
    tabRecycle,
    tabWaiting,
  },
})
export default class extends Vue {
  activeName: string = "latent";
  isCollapse = false;
  created() {
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      this.activeName = this.$route.params.tab || "latent";
    } else {
      const cache = PageModule.pageInfo.recruitLatent;
      if (cache.tab) {
        this.activeName = cache.tab;
      }
    }
  }
  handleTabChange(tab: any, event: any) {
    eventBus.$emit("latent-list-update-" + tab.name);
    PageModule.SET_PAGE_INFO({
      name: "recruitLatent",
      key: "tab",
      value: tab.name,
    });
  }
  toStudentRules() {
    PageModule.SET_PAGE_INFO({
      name: "approvalRule",
      key: "tab",
      value: "student",
    });
    this.$router.push({
      name: "approveRule",
    });
  }
}
